import React from "react";
import {Header} from "../Header/Header.jsx";
import {MainContentLayout} from "../MainContent/MainContentLayout.jsx";
import {useAuth} from "../../../context/AuthContext.jsx";
import {TopNav} from "../SubNavigation/TopNav/TopNav.jsx";
import {Breadcrumbs} from "../../base/Breadcrumb.jsx";
import {GridContainerFlex} from "../GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../GridFlex/GridItemFlex/GridItemFlex.jsx";
import {LeftNav} from "../SubNavigation/LeftNav/LeftNav.jsx";
import {RightNav} from "../SubNavigation/RightNav/RightNav.jsx";

export const PageLayout = ({
                               showHeader = true,
                               showFooter = false,
                               showNav = false,
                               navPosition, navLinks,
                               showBreadcrumbs = true,
                               children
                           }) => {
    const {userIsAuthenticated} = useAuth();
    const containerStyles = {
        margin: "0 auto",
    }

    const wrappedChildren = (
        <MainContentLayout>
            {children}
        </MainContentLayout>
    )


    const render = () => {
        if(showNav) {
            if(navPosition === "top") {
                return (
                    <>
                        <GridItemFlex xs={12}>
                            <TopNav navLinks={navLinks} />
                        </GridItemFlex>
                        <GridItemFlex xs={12}>
                            {wrappedChildren}
                        </GridItemFlex>
                    </>
                )
            }
            else if(navPosition === "left") {
                return (
                        <GridItemFlex xs={12}>
                            <LeftNav navLinks={navLinks} children={wrappedChildren} />
                        </GridItemFlex>
                    )
                }
            else if(navPosition === "right") {
                return (
                    <GridItemFlex xs={12}>
                        <RightNav navLinks={navLinks} children={wrappedChildren} />
                    </GridItemFlex>
                )
            }
        } else {
            return (
                <GridItemFlex xs={12}>
                    {wrappedChildren}
                </GridItemFlex>
            )
        }
    }

    return (
        <GridContainerFlex style={containerStyles}>
            {(showHeader && userIsAuthenticated) &&
                <GridItemFlex xs={12}>
                    <Header />
                </GridItemFlex>
            }
            {showBreadcrumbs &&
                <GridItemFlex xs={12}>
                    <Breadcrumbs />
                </GridItemFlex>
            }
            {render()}
            {/*{showFooter && <Footer />}*/}
        </GridContainerFlex>
    );
};

